import { createFileRoute } from '@tanstack/react-router';
import { InstallTimeView } from '@/components/InstallTimeView';

export const Route = createFileRoute('/_authenticated/install-times')({
  component: InstallTimeView,
});

